import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Http} from '@angular/http';
import {Constants} from '../../../shared/Constants';
import {User} from '../../mocks/user/user.model';
import {Observable} from 'rxjs';
import {TransactionsResponse} from '../../mocks/transactionsResponse.model';
import {PagedDataModel} from '../../mocks/paged-data.model';

export interface PagedTransactionData extends PagedDataModel {
  content: Array<TransactionsResponse>;
}


@Injectable()
export class UserService {
  // Observable string sources
  public emitChangeSource = new Subject();

  // Observable string streams
  changeEmitted$ = this.emitChangeSource.asObservable();
  public loggedInUser: User;

  // Service message commands
  emitChange(change: string) {
    this.emitChangeSource.next(change);
  }

  constructor(public http: Http) {
    if ((JSON.parse(localStorage.getItem(Constants.PROFILE)))){
      this.loggedInUser = new User(JSON.parse(localStorage.getItem(Constants.PROFILE)));
    }
  }

  /**
   * get agents
   * @param formData
   * @param token
   */

  getAdmins() {
    return this.http.get(Constants.ADMIN_URL + '?all=1', Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getAgents(userId ?: number, offset = 0, pageSize = 20,  search = '') {
    return this.http.get(Constants.AGENT_URL + (pageSize ? '?pageSize=' + pageSize : '') + (userId ? '&superAgentId=' + userId : '')
      + (offset ? '&offset=' + offset : '') + (search ? '&search=' + search : ''), Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // 0 - for pending, 1 - for approved, 2 - all
  getFrozenAccounts(type = 2) {
    return this.http.get(Constants.FREEZE_ACCOUNT_URL + (type ? '?status=' + type : ''), Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getStatistics() {
    return this.http.get(Constants.ADMIN_STATISTICS_URL, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // chart statistics
  getChartStatistics() {
    return this.http.get(Constants.CHART_REPORT_STATISTICS_URL, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // deprecated
  getAgentTransactions(userId: number, period: string, useRange: boolean, all = false) {
    if (all){
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + '/' + userId,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange == false) {
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + '/' + userId  + '/' + period,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange) {
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + '/' + userId + period + '&status=2',
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }

    return this.http.get(Constants.AIRTIME_TRANSACTIONS + '/' + userId,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getRecentTransactions(userId: number, offset = 0, pageSize = 20) {
    return this.http.get(Constants.AIRTIME_TRANSACTIONS + '/' + userId + '?offset=' + offset + '&pageSize=' + pageSize + '&downloadSuccessful=1&downloadFailed=1&downloadPending=1',
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getAirtimeTransactions(userId: number, period: string, useRange: boolean, download = 0, success = 1, failed = 1, pending = 1) {
    if (period && useRange == false && download == 0) {
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + (userId ? '/' + userId : '')  + '/' + period,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange && download == 0) {
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + (userId ? '/' + userId : '') + '/'  + period + '&status=2',
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange == false && download == 1) {
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + (userId ? '/' + userId : '')  + '/' + period + 'download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed + '&downloadPending=' + pending,
        Constants.getFileRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)));
    }
    else if (period && useRange && download == 1) {
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + (userId ? '/' + userId : '') + '/' + period + 'download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed + '&downloadPending=' + pending,
        Constants.getFileRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)));
    }
    return this.http.get(Constants.AIRTIME_TRANSACTIONS + (userId ? userId : ''),
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // https://onerecharge.com/onerecharge/api/reports/transactions/today?offset=1&pageSize=20&status=2&download=1&downloadSuccessful=1&downloadFailed=1&downloadPending=1





  getAdminWalletTransactions(userId: number, period: string, useRange: boolean, offset = 1, pageSize = 20, status = 2,  download = 0, success = 1, failed = 1){
    if (period && useRange == false && download == 0) {
      return this.http.get(Constants.WALLET_TRANSACTIONS_URL + (userId ? '/' + userId : '')  + '/' + period + '?offset=' + offset + '&pageSize=' + pageSize + '&status=' + status + '&download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange && download == 0) {
      return this.http.get(Constants.WALLET_TRANSACTIONS_URL + (userId ? '/' + userId : '') + '/'  + period + '&offset=' + offset + '&pageSize=' + pageSize + '&status=' + status + '&download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange == false && download == 1) {
      return this.http.get(Constants.WALLET_TRANSACTIONS_URL + (userId ? '/' + userId : '')  + '/' + period + '?offset=' + offset + '&pageSize=' + pageSize + '&status=' + status + '&download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed,
        Constants.getFileRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)));
    }
    else if (period && useRange && download == 1) {
      return this.http.get(Constants.WALLET_TRANSACTIONS_URL + (userId ? '/' + userId : '') + '/' + period + '?offset=' + offset + '&pageSize=' + pageSize + '&status=' + status + '&download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed,
        Constants.getFileRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)));
    }
    return this.http.get(Constants.WALLET_TRANSACTIONS_URL + (userId ? userId : ''),
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  getWalletTransactionsByPeriod(period?: string, download = 0, success = 1, failed = 1, pending = 1) {
    if (period && download == 0) {
      return this.http.get(Constants.WALLET_TRANSACTIONS + '/' + period,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && download == 1) {
      return this.http.get(Constants.WALLET_TRANSACTIONS + '/' + period + 'download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed + '&downloadPending=' + pending,
        Constants.getFileRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)));
    }
    return this.http.get(Constants.WALLET_TRANSACTIONS,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  getAgentWalletTransactions(userId: number, period: string, useRange: boolean, download = 0, success = 1, failed = 1, pending = 1) {
    if (period && useRange == false && download == 0) {
      return this.http.get(Constants.USERS_WALLET_TRANSACTIONS_URL  + (userId ? '/' + userId : '') + '/' + period,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange && download == 0) {
      return this.http.get(Constants.USERS_WALLET_TRANSACTIONS_URL  + (userId ? '/' + userId : '') + '/' +  period + '&status=2',
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange == false && download == 1) {
      return this.http.get(Constants.USERS_WALLET_TRANSACTIONS_URL  + (userId ? '/' + userId : '') + '/' + period + '?download=' + download
      + '&downloadSuccessful=' + success + '&downloadFailed=' + failed + '&downloadPending=' + pending,
        Constants.getFileRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)));
    }
    else if (period && useRange && download == 1) {
      return this.http.get(Constants.USERS_WALLET_TRANSACTIONS_URL  + (userId ? '/' + userId : '') + '/' +  period + '&download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed + '&downloadPending=' + pending,
        Constants.getFileRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)));
    }
    return this.http.get(Constants.USERS_WALLET_TRANSACTIONS_URL + userId,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getAdminTransactions(userId: number, period: string, useRange: boolean, offset = 1, pageSize = 20, status = 2,  download = 0, success = 1, failed = 1, pending = 1){
    if (period && useRange == false && download == 0) {
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + (userId ? '/' + userId : '')  + '/' + period + '?offset=' + offset + '&pageSize=' + pageSize + '&status=' + status + '&download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed + '&downloadPending=' + pending,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange && download == 0) {
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + (userId ? '/' + userId : '') + '/'  + period + '&offset=' + offset + '&pageSize=' + pageSize + '&status=' + status + '&download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed + '&downloadPending=' + pending,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange == false && download == 1) {
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + (userId ? '/' + userId : '')  + '/' + period + '?status=' + status + '&download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed + '&downloadPending=' + pending,
        Constants.getFileRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)));
    }
    else if (period && useRange && download == 1) {
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + (userId ? '/' + userId : '') + '/' + period + '&status=' + status + '&download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed + '&downloadPending=' + pending,
        Constants.getFileRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)));
    }
    return this.http.get(Constants.AIRTIME_TRANSACTIONS + (userId ? userId : ''),
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  retryTransaction(tranxId: any){
    return this.http.put(Constants.TRANSACTIONS + '/retry/' + tranxId , {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // https://test.mfisa.com/tig/api/transactions/refund/741478021a7b40ed89b6348d1b9fa4e1
  refundTransaction(tranxId: any){
    return this.http.put(Constants.TRANSACTIONS + '/refund/' + tranxId , {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  updateTransactionToSuccess(tranxId: any){
    return this.http.put(Constants.TRANSACTIONS + '/update-successful/' + tranxId , {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


 // fund-requests-range?startDate=1522540800000&endDate=1522972800000&status=2

  getFundRequestHistory(period?: string, useRange?: boolean) {
    if (period && useRange == false) {
      return this.http.get(Constants.FUND_REQUESTS + '?status=2',
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange) {
      return this.http.get(Constants.FUND_REQUESTS_RANGE + period + '&status=2',
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    return this.http.get(Constants.FUND_REQUESTS_HISTORY,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  // https://137.74.50.58/golden-rule/api/wallet/agent-fund-requests/6?status=2
  getAgentFundRequestHistory(userId: number, period?: string, useRange?: boolean) {
    if (period == 'all' && useRange == false) {
      return this.http.get(Constants.AGENT_FUND_REQUESTS + '/' + userId + '?status=2',
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange) {
      return this.http.get(Constants.AGENT_FUND_REQUESTS_RANGE + '/' + userId + period + '&status=2',
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    return this.http.get(Constants.AGENT_FUND_REQUESTS + '/' + userId + '?status=2',
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
    // return this.http.get(Constants.FUND_REQUESTS_HISTORY,
    //   Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
    //   .map(res => res.json());
  }



  // get all customers
  getCustomers() {
    return this.http.get(Constants.CUSTOMER_URL, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  // type :  1 = Airtime Transactions, 2 = wallet transactions
  // status : -1 = pending, 0 = failed, 1 = successful, 2 = all

  getUserTransactions(userId: number, transactionType = 1, status = 1) {
    return this.http.get(Constants.USER_TRANSACTIONS + '/' + userId + '?transactionType=' + transactionType + '&status=' + status, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  getTransactionsByUser(userId: number, pageSize = 10) {
    return this.http.get(Constants.AIRTIME_TRANSACTIONS + '/' + userId + '?pageSize=' + pageSize, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // https://137.74.50.58/onerecharge/api/reports/transactions/48?pageSize=5

  // get all Payouts
  getPayouts() {
    return this.http.get(Constants.PAYOUTS_URL, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // request payout
  requestPayout(amount: number) {
    return this.http.post(Constants.PAYOUTS_URL + '/request-new?amount=' + amount, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // approve payout
  approvePayout(id: number) {
    return this.http.put(Constants.PAYOUTS_URL + '/approve-payout/'  + id, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // confirm payout
  confirmPayout(id: number) {
    return this.http.put(Constants.PAYOUTS_URL + '/confirm-payout/'  + id, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // decline payout
  declinePayout(id: number) {
    return this.http.put(Constants.PAYOUTS_URL + '/decline-payout/'  + id, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // update customer
  updateCustomer(userData: any, userId: number) {
    return this.http.put(Constants.CUSTOMER_URL + 'update/' + userId, userData,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  customerRecharge(rechargeObj: any){
    console.log('customer Recharge payload ', rechargeObj);
    return this.http.post(Constants.CUSTOMER_RECHARGE, rechargeObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  customerBuyData(dataObj: any){
    console.log('customer data payload ', dataObj);
    return this.http.post(Constants.CUSTOMER_BUY_DATA, dataObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  guestRecharge(rechargeObj: any){
    console.log('guest Recharge payload ', rechargeObj);
    return this.http.post(Constants.GUEST_RECHARGE, rechargeObj,
      Constants.getNoTokenRequestOption())
      .map(res => res.json());
  }


  guestBuyData(dataObj: any){
    console.log('guest data payload ', dataObj);
    return this.http.post(Constants.GUEST_BUY_DATA, dataObj,
      Constants.getNoTokenRequestOption())
      .map(res => res.json());
  }


  agentSelfFundWallet(fundObj: any){
    console.log('agent fund wallet payload ', fundObj);
    return this.http.post(Constants.AGENT_URL + 'self-fund', fundObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

// block user
  blockUser(setId: any) {
    return this.http.put(Constants.USERS_URL + setId + Constants.BLOCK, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // resend mail to user resend?adminId=22
  resendActivationMail(setId: any) {
    return this.http.get(Constants.ACTIVATION_URL + 'resend?adminId=' + setId,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // get user
  getUser(setId: any) {
    return this.http.get(Constants.USERS_URL + setId,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

// unblock user
  unblockUser(setId: any) {
    return this.http.put(Constants.USERS_URL + setId + Constants.UNBLOCK, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  deleteUser(setId: any) {
    return this.http.delete(Constants.USERS_URL + setId + Constants.DELETE,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // update agent
  updateUser(userData: any, userId: number) {
    return this.http.put(Constants.AGENT_URL + 'update/' + userId, userData,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  fundWallet(agentId: any, amount: number){
    console.log('where are here as : ', this.loggedInUser);

    if (this.loggedInUser.userType == Constants.AGENT_USERTYPE) {
      return this.http.post(Constants.AGENT_URL + 'fund-wallet/' + agentId + '/' + amount, {},
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
      map(res => res.json());
    }
    else if (this.loggedInUser.userType == Constants.ADMIN_USERTYPE) {
      return this.http.post(Constants.WALLET_URL + '/fund', {'amount': amount, 'userId': agentId},
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
      map(res => res.json());
    }
  }

  freezeAccount(freezeObj: any){
    return this.http.post(Constants.FREEZE_ACCOUNT, freezeObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  airtimeRecharge(rechargeObj: any){
    return this.http.post(Constants.AGENTS_RECHARGE, rechargeObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  // multiple user by uploading sheet
  //  // recharge/bulk?channel=web&fromWallet=WALLET_MAIN
  bulkAirtimeRecharge(formData: FormData) {
    return this.http.post(Constants.UPLOAD_BULK_RECHARGE_URL + '?channel=web&fromWallet=WALLET_MAIN', formData,
      Constants.getMultipartRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }



  dataRecharge(dataObj: any){
    return this.http.post(Constants.AGENTS_BUY_DATA, dataObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }


  // request funding and upload sheet
  requestFunding(fundingData: any, formData) {
    let payload = '';
    for (const key in fundingData){
      if (fundingData.hasOwnProperty(key)){
        payload += '' + key + '=' + fundingData[key] + '&';
      }
    }
    payload = payload.replace(/&+$/g, ''); // remove the trailing &
    console.log('******* payload ********');
    console.log(payload);
    return this.http.post(Constants.REQUEST_FUNDING + payload, formData,
      Constants.getMultipartRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  updateNetworkConfig(id, networkObj: any){
    return this.http.put(Constants.NETWORK_URL + id + '/update', networkObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }


  // get airtime network config
  getAirtimeNetworkConfig() {
    return this.http.get(Constants.NETWORK_URL + 'airtime-config', Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  // get user airtime network config
  getUserAirtimeNetworkConfig(userID) {
    return this.http.get(Constants.NETWORK_URL + 'user-airtime-network-config/' + userID,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // get loggedIn user airtime network config
  getLoggedInUserAirtimeNetworkConfig() {
    return this.http.get(Constants.NETWORK_URL + 'user-airtime-network-config/',
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // get loggedIn user data network config
  getLoggedInUserDataNetworkConfig() {
    return this.http.get(Constants.NETWORK_URL + 'user-data-network-config/',
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  deleteUserAirtimeNetworkConfig(setId: any) {
    return this.http.delete(Constants.NETWORK_URL + 'user-airtime-network-config/' + setId,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  updateAirtimeNetworkConfig(id, networkObj: any){
    return this.http.put(Constants.NETWORK_URL + '/airtime-config/' + id, networkObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  // block airtime network
  blockAirtimeNetwork(setId: any) {
    return this.http.put(Constants.NETWORKS_URL + setId + '/block-airtime', {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // unblock airtime network
  unblockAirtimeNetwork(setId: any) {
    return this.http.put(Constants.NETWORKS_URL + setId + '/unblock-airtime', {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // block data network
  blockDataNetwork(setId: any) {
    return this.http.put(Constants.NETWORKS_URL + setId + '/block-data', {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // unblock data network
  unblockDataNetwork(setId: any) {
    return this.http.put(Constants.NETWORKS_URL + setId + '/unblock-data', {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // get data network config
  getDataNetworkConfig() {
    return this.http.get(Constants.NETWORK_URL + 'data-config', Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // get user data network config
  getUserDataNetworkConfig(userID) {
    return this.http.get(Constants.NETWORK_URL + 'user-data-network-config/' + userID, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  deleteUserDataNetworkConfig(setId: any) {
    return this.http.delete(Constants.NETWORK_URL + 'user-data-network-config/' + setId,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  createUserDataNetworkConfig(configObj: any){
    return this.http.post(Constants.NETWORK_URL + 'user-data-network-config/', configObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  createUserAirtimeNetworkConfig(configObj: any){
    return this.http.post(Constants.NETWORK_URL + 'user-airtime-network-config/', configObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  updateDataNetworkConfig(id, networkObj: any){
    return this.http.put(Constants.NETWORK_URL + 'data-config/' + id, networkObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  getFundRequestsHistory() {
    return this.http.get(Constants.FUND_REQUESTS_HISTORY,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // get all networks
  getNetworks() {
    return this.http.get(Constants.NETWORK_URL, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }



// unblock user
  unblockNetwork(setId: any) {
    return this.http.put(Constants.NETWORKS_URL + setId + Constants.UNBLOCK, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // update network
  updateNetwork(networkFormData: any , id: any) {
    return this.http.put(Constants.NETWORKS_URL + id + '/update/', networkFormData,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  deleteNetwork(setId: any) {
    return this.http.delete(Constants.NETWORKS_URL + setId + Constants.DELETE,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  getFundRequests() {
    return this.http.get(Constants.FUND_REQUESTS + '?status=0',
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getCommissionAccounts() {
    return this.http.get(Constants.COMMISSION_ACCOUNTS,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  declineFundAgent(requestId: number) {
    return this.http.put(Constants.MANAGE_FUND_REQUEST_URL + '/' + requestId + '/decline', null,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  acceptFundAgent(requestId: number) {
    return this.http.put(Constants.MANAGE_FUND_REQUEST_URL + '/' + requestId + '/accept', null,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  fundAgent(paymentDetails: any) {
    return this.http.post(Constants.FUND_AGENT, paymentDetails, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  agentSelfFund(fundObj: any){
    return this.http.post(Constants.AGENTS_SELF_FUND, fundObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  updateAdmin(userFormData: any, id) {
    return this.http.put(Constants.ADMIN_UPDATE_URL + id , userFormData,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // update agent
  updateAgent(agentData: any, agentId: number) {
    return this.http.put(Constants.AGENT_URL + 'update/' + agentId, agentData,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getUserAgents(id) {
    return this.http.get(Constants.AGENT_URL + '?superAgentId=' + id,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getUserPermission(id) {
    return this.http.get(Constants.USER_PERMISSIONS_URL + id,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/users-service/user-service.ts